/**
 * @module components/theme/Unauthorized/Unauthorized
 */

import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { Container } from 'semantic-ui-react';
import { useLocation } from 'react-router-dom';
import { withServerErrorCode } from '@plone/volto/helpers/Utils/Utils';
import { getBaseUrl } from '@plone/volto/helpers/Url/Url';

/**
 * unauthorized function.
 * @function Unauthorized
 * @returns {string} Markup of the unauthorized page.
 */
const Unauthorized = () => {
  let location = useLocation();

  return (
    <Container className="view-wrapper error-page">
      <h3>
        <FormattedMessage id="Unauthorized" defaultMessage="Unauthorized" />
      </h3>
      <p className="description">
        <FormattedMessage
          id="You are not authorized to access this resource."
          defaultMessage="You are not authorized to access this resource."
          values={{
            login: (
              <Link to={`${getBaseUrl(location.pathname)}/login`}>
                <FormattedMessage id="log in" defaultMessage="log in" />
              </Link>
            ),
          }}
        />
      </p>
    </Container>
  );
};

export default withServerErrorCode(401)(Unauthorized);
